import { Box } from "@mui/material";
import { useSyncExternalStore } from "react";
import { ProgressIndicator } from "../components/ui/ProgressIndicator";
import { useThemeContext } from "../globalContext/global-context";
import type { SurveySession } from "../session/SurveySession";

export const SurveyProgress = ({ session }: { session: SurveySession }) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const snapshot = useSyncExternalStore(session.subscribe, session.getSnapshot);
  const progress = snapshot.attempt?.question.pct_progress;
  if (
    !theme.show_progress ||
    progress === undefined ||
    !Number.isFinite(progress)
  )
    return null;
  return (
    <Box
      data-testid="survey-progress"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 48,
        height: 48,
        borderRadius: `${theme.tokens.shape.radius.pill}px`,
        backgroundColor: theme.tokens.color.action.primary,
        boxShadow:
          theme.layout.orientation === "landscape"
            ? theme.tokens.elevation["2"]
            : undefined,
      }}
    >
      <ProgressIndicator
        showProgress
        progress={progress}
        color={theme.tokens.color.surface.card}
        surveyTheme={theme}
      />
    </Box>
  );
};
